import { Navigate, type RouteObject } from 'react-router-dom';
import AlertPage from './pages/AlertPage';
import AlertsPage from './pages/AlertsPage';

const routes: RouteObject[] = [
  {
    index: true,
    element: <AlertsPage />,
  },
  {
    path: ':id',
    children: [
      {
        index: true,
        element: <Navigate to="details" replace />,
      },
      {
        path: ':tab',
        element: <AlertPage />,
      },
    ],
  },
];

export default routes;
